import { ArrowDropDown } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  Chip,
  InputAdornment,
  Link,
  Menu,
  MenuItem,
  TextField
} from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { FILTER_PAYLOAD_KEY } from ".";
import { ReactComponent as ThinArrowIcon } from "../../../assets/icons/thin-arrow-icon.svg";
import { RootState } from "../../../store/reducers";
import { getFiltersList } from "../../../store/slices/jobPricingSlice";
import { resetJobPricingList } from "../../../store/slices/SJPR/listSlice";
import Styles from "./chip.module.scss";
import "./chip.scss";

export const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: "20px",
    border: "1px solid #8F918D",
    height: "41px",
    padding: "0 10px",
    margin: "0 10px",
    "& fieldset": {
      borderRadius: "20px"
    }
  }
});

interface ChipsWithDropdownProps {
  name: string;
  label: string;
  options: any;
  values?: any;
  onChipChange: any;
  onClose: (event: any, reason: string) => void;
  count?: number;
  headerLinkText?: string;
  headerLinkUrl?: string;
  singleSelect?: boolean;
}
export const ChipsWithDropdown: FC<ChipsWithDropdownProps> = ({
  name,
  label,
  options,
  values,
  onChipChange,
  onClose,
  count: externalCount,
  headerLinkText,
  headerLinkUrl,
  singleSelect = false
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemsTodisplay, setItemsToDisplay] = useState<any>({
    showItemsCount: 3,
    expanded: false
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState<any>();
  const [hadValuesOnOpen, setHadValuesOnOpen] = useState(false);
  const [valuesOnOpen, setValuesOnOpen] = useState<any>([]);
  const { jobPricingList } = useSelector((state: any) => {
    return state;
  });

  const handleClick = (event: any, name: any) => {
    setValuesOnOpen(Array.isArray(values) ? [...values] : []);
    setHadValuesOnOpen(values.length > 0);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (shouldRestore = true) => {
    if (shouldRestore) {
      onChipChange({ type: "RESTORE", values: valuesOnOpen });
    }
    setAnchorEl(null);
    setFilteredItems(options);
  };

  const isApplyButtonDisabled = () => {
    if (values.length > 0 && values.some((_val: any) => _val?.key)) {
      return false;
    }
    return !hadValuesOnOpen;
  };

  const isOptionCheck = (option: any): boolean => {
    if (values.length > 0) {
      let isChecked = values?.filter((_sel: any) => _sel.key == option.key);
      return isChecked.length > 0 ? true : false;
    } else {
      return false;
    }
  };

  const handleSearch = (value: any) => {
    setFilteredItems(
      options?.filter((item: any) =>
        item?.label?.toLowerCase().includes(value?.trim().toLowerCase())
      )
    );
  };
  const getCount = (name: string, label: string) => {
    let count = 0;
    /* if (jobPricingList?.filtersCount) {
      count = jobPricingList?.filtersCount[name];
    } */
    if (externalCount !== undefined) {
      count = externalCount;
    } else if (name === "peer-groups") {
      const peerGroupId = jobPricingList?.peerGroupId;
      if (Array.isArray(peerGroupId)) {
        count = peerGroupId.length;
      } else if (peerGroupId) {
        count = 1;
      }
    } else if (jobPricingList?.filters) {
      count = jobPricingList?.filters[name]?.length;
    }
    return (
      <>
        {label}{" "}
        {count > 0 && (
          <span
            style={{
              backgroundColor: "#00C29B",
              padding: "10px 5px",
              marginLeft: "5px",
              borderRadius: "20px"
            }}
          >
            {count}
          </span>
        )}
      </>
    );
  };
  // const isAllIntermediate = (opt: any) => {
  //   return (
  //     values.length > 0 &&
  //     filteredItems.length - 1 != values.length &&
  //     opt.key == "ALL"
  //   );
  // };
  useEffect(() => {
    dispatch(getFiltersList());
    setFilteredItems(options);
  }, []);

  return (
    <>
      {(options.length > 0 || name === "peer-groups") ? (
        <div>
          <Chip
            key={name}
            label={getCount(name, label)}
            onClick={(event: any) => handleClick(event, name)}
            deleteIcon={<ArrowDropDown />}
            onDelete={(event: any) => handleClick(event, name)}
            style={{ margin: 5 }}
            className={Styles.dropdownChip}
          />
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => handleClose()}
            className={Styles.optionsModel}
            autoFocus={false}
          >
            <div className={Styles.optionsModelHeader}>
              <div className={Styles.optionsModelHeading}>
                <p className={Styles.optionsModelHeadingText}>{label}</p>
                <CloseIcon
                  style={{
                    cursor: "pointer"
                  }}
                  onClick={() => handleClose()}
                />
              </div>
              {headerLinkText && headerLinkUrl && (
                <Link
                  href={headerLinkUrl}
                  className={Styles.headerLink}
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    window.open(headerLinkUrl, "_self");
                  }}
                >
                  {headerLinkText} <ThinArrowIcon width={16} height={16} />
                </Link>
              )}
              <CustomTextField
                // id="outlined-basic"
                className={Styles.inputSearchBox}
                variant="outlined"
                autoComplete="off"
                placeholder={t("pa.filter.Search")}
                onChange={(e: any) => handleSearch(e.currentTarget.value)}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </div>
            <div>
              {filteredItems && filteredItems.length > 0 ? (
                filteredItems.map((option: any) => (
                  <MenuItem
                    onClick={() => {
                      if (singleSelect) {
                        if (!isOptionCheck(option)) {
                          onChipChange(option, "SELECT");
                        }
                        handleClose(false);
                        return;
                      }
                      onChipChange(option);
                    }}
                    key={option?.key}
                    className={`${Styles.optionsModelItem} ${
                      singleSelect ? Styles.optionsModelItemSingle : ""
                    } ${
                      singleSelect && isOptionCheck(option)
                        ? Styles.optionsModelItemSelected
                        : ""
                    }`}
                    selected={singleSelect && isOptionCheck(option)}
                  >
                    {!singleSelect && (
                      <Checkbox
                        key={option?.key}
                        name={option?.key}
                        style={{ marginRight: 4 }}
                        color="secondary"
                        checked={isOptionCheck(option)}
                        sx={{
                          pointerEvents: "auto",
                          "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                            color: "var(--primary-color)"
                          }
                        }}
                      //indeterminate={isAllIntermediate(option)}
                      />
                    )}
                    {option?.label}
                  </MenuItem>
                ))
              ) : (
                <div style={{ padding: "10px 20px" }}>{t("pa.noOptionAvailable")}</div>
              )}
            </div>
            {!singleSelect && <div className={Styles.buttonsBlock}>
              <Button
                onClick={(event: any) => {
                  let reason = "";
                  onClose(event, reason);
                  handleClose(false);
                  dispatch(resetJobPricingList());
                }}
                variant="contained"
                color="primary"
                className={Styles.applyButton}
                disabled={isApplyButtonDisabled()}
                sx={{
                  backgroundColor: "var( --primary-color)",
                  color: "var(--contained-button-text)",
                  textTransform: "none",
                  fontWeight: 700,
                  "&:hover": {
                    backgroundColor: "var(--primary-color)"
                  }
                }}
              >
                {t("pa.apply")}
              </Button>
              <Button
                onClick={(event: any) => {
                  let updatedFilterPayload: any = {
                    ...jobPricingList?.filters
                  };

                  const hasAppliedFilter =
                    name === "peer-groups"
                      ? !!jobPricingList?.peerGroupId
                      : updatedFilterPayload[name]?.length > 0;

                  if (hasAppliedFilter) {
                    let reason = "CLEAR_ALL";
                    onClose(event, reason);
                    handleClose(false);
                    dispatch(resetJobPricingList());
                  } else {
                    onChipChange("CLEAR_ALL");
                  }
                }}
                color="primary"
                className={`${Styles.clearButton}`}
                disabled={isApplyButtonDisabled()}
                sx={{ textTransform: "none", fontWeight: 700 }}
              >
                {t("pa.clearAll")}
              </Button>
            </div>}
          </Menu>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

// ++++++++++++++ ChipsWithMultiDropdown +++++++++++++
export const ChipsWithMultiDropdown: FC<any> = ({
  filters,
  values,
  onClose,
  onChipMultiChange
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedFiltersCount, setSelectedFiltersCount] = useState<any>();
  const [searchTerm, setSearchTerm] = useState<any>({});
  const [filteredItems, setFilteredItems] = useState<any>();
  const [isActive, setIsActive] = useState(false);
  const [hadValuesOnOpen, setHadValuesOnOpen] = useState(false);
  const [valuesOnOpen, setValuesOnOpen] = useState<any>({});
  const { jobPricingList } = useSelector((state: any) => {
    return state;
  });

  const checkFiltersAllEmpty = () => {
    return Object.keys(filters || {}).some(
      (_filter: any, index: any) => filters[_filter]?.length > 0
    );
  };

  const handleClick = (event: any, name: any) => {
    let hasValues = false;
    const snapshot: any = {};
    for (const key in filters) {
      snapshot[key] = values[key] ? [...values[key]] : [];
      if (values[key]?.length > 0) {
        hasValues = true;
      }
    }
    setValuesOnOpen(snapshot);
    setHadValuesOnOpen(hasValues);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (shouldRestore = true) => {
    if (shouldRestore) {
      onChipMultiChange({ type: "RESTORE", values: valuesOnOpen });
    }
    setAnchorEl(null);
    setFilteredItems(filters);
  };

  const getFilterLabel = (filterkey: string) => {
    const filterswithLabel: any = {
      jobfamily: t("pa.jobFamily"),
      jobsubfamily: t("pa.jobSubFamily"),
      industry: t("pa.industryTitle"),
      incumbent: t("pa.incumbentsClass"),
      region: t("pa.regionTitle"),
      clientownership: t("pa.ownership"),
      numofemp: t("pa.employeeCountTitle"),
      revenuerangedesc: t("pa.revenueRangeTitle"),
      grade: t("pa.grade")
    };
    for (let key in filterswithLabel) {
      if (filterkey == key) {
        return filterswithLabel[key];
      }
    }
  };

  const isApplyButtonDisabled = () => {
    let _selectedItems: any = [];
    for (let key in values) {
      if (values[key]?.length) {
        values[key]?.map((_item: any) => {
          _selectedItems.push(_item);
        });
      }
    }
    if (_selectedItems?.length > 0) return false;
    return !hadValuesOnOpen;
  };

  const getfiltersWithAll = (filters: any) => {
    let filtersWithAll = [...filters];
    filters?.length > 1 &&
      filtersWithAll.unshift({ key: "ALL", label: t("pa.selectAll") });
    return filtersWithAll;
  };

  const handleSearch = (value: any, _filter: any) => {
    setSearchTerm({
      ...searchTerm,
      [_filter]: value
    });
    let _filtered = filters[_filter].filter((_fil: any) =>
      _fil?.label?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredItems({
      ...filteredItems,
      [_filter]: _filtered
    });
  };
  const handleClearAllClick = () => {
    let updatedFilterPayload: any = {
      ...jobPricingList?.filters
    };
    Object.keys(filters)?.map((_filter: any, index: any) => {
      for (let _fil in updatedFilterPayload) {
        updatedFilterPayload[_filter];
      }
    });

    let isClearAllSelectedFilters = Object.keys(filters)?.some(
      isFilterAlreadySelected
    );

    function isFilterAlreadySelected(_fil: any) {
      return updatedFilterPayload[_fil].length > 0;
    }
    if (isClearAllSelectedFilters) {
      let reason = "CLEAR_ALL";
      onClose(event, reason);
      handleClose(false);
      dispatch(resetJobPricingList());
    } else {
      onChipMultiChange("CLEAR_ALL", filters);
    }
  };
  useEffect(() => {
    filters && setFilteredItems(filteredItems || filters);
    setSearchTerm({});
  }, [filters]);

  const isAllIntermediate = (filter: any, opt: any) => {
    return (
      values[filter]?.length > 0 &&
      filteredItems[filter]?.length + 1 != values[filter]?.length &&
      opt.key == "ALL"
    );
  };

  const isSelectAllDisabled = (filter: string) => {
    if (filter !== 'grade') return false;
    const gradeOptions = filteredItems?.[filter] || [];
    return gradeOptions.length > 3;
  };

  const isOptionDisabled = (filter: string, opt: any) => {
    if (filter !== 'grade') return false;
    if (opt.key === 'ALL') return isSelectAllDisabled(filter);

    const currentSelections = values[filter]?.filter((v: any) => v.key !== 'ALL') || [];
    const isAlreadySelected = currentSelections.some((v: any) => v.key === opt.key);

    return currentSelections.length >= 3 && !isAlreadySelected;
  };

  const renderFilters = () => {
    return Object.keys(filters)?.map((_filter: any, index: any) => {
      return (
        filters[_filter]?.length > 0 && (
          <Accordion className={Styles.moreFiltersaccordion} key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <p className={Styles.optionsModelHeadingText}>
                {getFilterLabel(_filter)}
              </p>
            </AccordionSummary>
            <AccordionDetails>
              <CustomTextField
                key={_filter}
                id="outlined-basic"
                variant="outlined"
                className={Styles.inputSearchBox}
                // value={(searchTerm && searchTerm[_filter]) || ""}
                placeholder="Search..."
                onChange={(e: any) => handleSearch(e.target.value, _filter)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
                sx={{ width: "100%" }}
                autoComplete="off"
              />
              <div className={Styles.moreFiltersAccordionDetails}>
                {filteredItems &&
                  getfiltersWithAll(filteredItems[_filter])?.map((opt: any) => {
                    const isDisabled = isOptionDisabled(_filter, opt);
                    return (
                      <MenuItem
                        onClick={() => {
                          if (!isDisabled) {
                            onChipMultiChange(opt, _filter);
                          }
                        }}
                        key={opt.key}
                        className={Styles.optionsModelItem}
                        sx={{
                          opacity: isDisabled ? 0.5 : 1,
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          pointerEvents: "auto",
                          "&:hover": isDisabled ? {
                            backgroundColor: "transparent"
                          } : {}
                        }}
                      >
                        <Checkbox
                          key={opt?.key}
                          name={opt?.key}
                          style={{ marginRight: 4 }}
                          color="secondary"
                          disabled={isDisabled}
                          disableRipple={isDisabled}
                          checked={
                            values[_filter]?.filter(
                              (_fil: any) => _fil.key === opt.key
                            ).length > 0
                              ? true
                              : false
                          }
                          sx={{
                            pointerEvents: isDisabled ? "none" : "auto",
                            "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                              color: "var(--primary-color)"
                            },
                            "&.Mui-disabled": {
                              color: "#bdbdbd",
                              backgroundColor: "transparent !important",
                              pointerEvents: "none",
                              "& .MuiSvgIcon-root": {
                                backgroundColor: "transparent !important"
                              },
                              "& .MuiTouchRipple-root": {
                                display: "none !important"
                              },
                              "&::before": {
                                display: "none !important",
                                content: "none"
                              },
                              "&::after": {
                                display: "none !important",
                                content: "none"
                              }
                            },
                            "&.Mui-disabled:hover": {
                              backgroundColor: "transparent !important"
                            },
                            "& .MuiTouchRipple-root": isDisabled ? {
                              display: "none !important"
                            } : {}
                          }}
                        //indeterminate={isAllIntermediate(_filter, opt)}
                        />
                        <span style={{ color: isDisabled ? "#9e9e9e" : "inherit" }}>
                          {opt?.label}
                        </span>
                      </MenuItem>
                    );
                  })}
              </div>
            </AccordionDetails>
          </Accordion>
        )
      );
    });
  };
  //  comented for future use if required to update the count onchange
  // useEffect(() => {
  //   let count = 0;
  //   let filteredItems: any = [];
  //   Object.keys(jobPricingList?.filtersCount)?.map((_item: any) => {
  //     Object.keys(filters)?.includes(_item)
  //       ? filteredItems.push(jobPricingList?.filtersCount[_item])
  //       : null;
  //   });
  //   filteredItems?.map((_count: any) => {
  //     count = count + _count;
  //   });
  //   setSelectedFiltersCount(count);
  // }, [jobPricingList?.filtersCount]);
  useEffect(() => {
    let count = 0;
    let filteredItems: any = [];
    Object.keys(filters)?.map((_item: any) => {
      filteredItems.push(jobPricingList?.filters[_item]?.length);
      return _item;
    });
    filteredItems?.map((_count: any) => {
      count = count + _count;
      return _count;
    });
    setSelectedFiltersCount(count);
  }, [jobPricingList?.filters]);

  return checkFiltersAllEmpty() ? (
    <div className={Styles.chipsWithMultiDropdownContainer}>
      <span>|</span>
      <Chip
        label={
          selectedFiltersCount ? (
            <>
              {t("pa.moreFilters")}
              <span
                style={{
                  backgroundColor: "#00C29B",
                  padding: "10px 5px",
                  marginLeft: "5px",
                  borderRadius: "20px"
                }}
              >
                {selectedFiltersCount}
              </span>
            </>
          ) : (
            t("pa.moreFilters")
          )
        }
        onClick={(event: any) => handleClick(event, name)}
        deleteIcon={<ArrowDropDown />}
        onDelete={(event: any) => handleClick(event, name)}
        style={{ margin: 5 }}
        className={Styles.dropdownChip}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        className={Styles.moreFiltersoptionsModel}
      >
        <div className={Styles.optionsModelHeader}>
          <div className={Styles.optionsModelHeading}>
            <p className={Styles.optionsModelHeadingText}>{t("pa.filters")}</p>
            <CloseIcon
              style={{
                cursor: "pointer"
              }}
              onClick={() => handleClose()}
            />
          </div>
        </div>
        {renderFilters()}
        <div className={Styles.buttonsBlock}>
          <Button
            onClick={(event) => {
              let reason = "";
              onClose(event, reason);
              handleClose(false);
            }}
            variant="contained"
            color="primary"
            className={Styles.applyButton}
            disabled={isApplyButtonDisabled()}
            sx={{
              backgroundColor: "var( --primary-color)",
              color: "var(--contained-button-text)",
              textTransform: "none",
              fontWeight: 700,
              "&:hover": {
                backgroundColor: "var(--primary-color)"
              }
            }}
          >
            {t("pa.apply")}
          </Button>
          <Button
            onClick={(event: any) => {
              handleClearAllClick();
            }}
            color="primary"
            className={Styles.clearButton}
            disabled={isApplyButtonDisabled()}
            sx={{ textTransform: "none", fontWeight: 700 }}
          >
            {t("pa.clearAll")}
          </Button>
        </div>
      </Menu>
    </div>
  ) : (
    <></>
  );
};
